<div class="skeleton-loader"
	 [class]="skeletonShape"
	*ngFor="let _ of [].constructor(skeletonCount)">
</div>
